module.exports = __webpack_public_path__ + "img/9ac815f0da9890bb55c4142b0eeed4f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/scripts/lib/images/finance_logo7.png
// module id = 915
// module chunks = 5